import { FOOTER_MJML } from "../common/footer";
import { MARKETING_HEADER } from "../common/header";

export const promotion = `
<mjml>
  <mj-head>
    <mj-title>Special Offer Just for You</mj-title>
    <mj-preview>Limited time discount inside</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
  </mj-head>
  <mj-body>
    ${MARKETING_HEADER("Special Offer!", "Limited Time Only")}
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">We're offering you an exclusive discount on our premium plan! As a valued customer, you deserve the best possible experience with our platform.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="30px">
      <mj-column>
        <mj-text font-size="36px" color="#ff5722" font-family="Arial, sans-serif" align="center" font-weight="bold">50% OFF</mj-text>
        <mj-text font-size="20px" color="#555555" font-family="Arial, sans-serif" align="center" padding-bottom="20px">Use code: <strong>SPECIAL50</strong></mj-text>
        <mj-button background-color="#ff5722" color="#ffffff" font-family="Arial, sans-serif" href="#" width="200px" border-radius="4px">Claim Offer</mj-button>
        <mj-text font-size="14px" color="#777777" font-family="Arial, sans-serif" align="center" padding-top="10px">Offer expires in 7 days. Terms and conditions apply.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column width="48%">
        <mj-image src="https://via.placeholder.com/300x200?text=Feature+1" alt="Premium Feature 1" />
        <mj-text font-size="18px" color="#333333" font-weight="bold">Advanced Analytics</mj-text>
        <mj-text font-size="14px" color="#555555">Gain deeper insights with our comprehensive analytics dashboard.</mj-text>
      </mj-column>
      <mj-column width="48%">
        <mj-image src="https://via.placeholder.com/300x200?text=Feature+2" alt="Premium Feature 2" />
        <mj-text font-size="18px" color="#333333" font-weight="bold">Priority Support</mj-text>
        <mj-text font-size="14px" color="#555555">Get immediate assistance whenever you need help.</mj-text>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "promotion",
  name: "Special Promotion",
  category: "marketing",
  description:
    "An attention-grabbing promotional email with a clear discount offer, perfect for special sales and limited-time offers.",
  features: [
    "Bold promotional header",
    "Clear discount presentation",
    "Product features showcase",
    "Urgency elements",
    "Strong call-to-action",
  ],
  subject: "Special Offer Just for You",
  subTitle: "Limited time discount inside",
  mjmlTemplate: promotion,
};
